<div class="feedback-dialog grid-y align-middle">
  <button
    aria-label="Close"
    type="button" class="close-btn" mat-icon-button mat-dialog-close>
    <mat-icon class="close-icon" svgIcon="close-blue"></mat-icon>
  </button>
  <ng-container *ngIf="!isSubmited">
    <section class="feedback-dialog__header grid-y align-middle">
      <img alt="" src="assets/images/dialog/feedback.svg" />

      <div class="cell">
        <div class="text-center font-semibold text-2xl">
          We appreciate your feedback!
        </div>
      </div>
    </section>
    <section class="feedback-dialog__body grid-y align-middle">
      <mat-tab-group class="w-full" dynamicHeight [selectedIndex]="data?.isIssue ? '1' : '0'" mat-align-tabs="center">
        <mat-tab label="Send Feedback">
          <div class="tab-content">
            <cpd-feedback (closeDialog)="dialogRef.close()" (feedback)="onFeedback($event)"></cpd-feedback>
          </div>
        </mat-tab>
        <mat-tab label="Report Issue">
          <div class="tab-content">
            <cpd-report-issue [systemReports]="publishedSystemReports$ | async" (closeDialog)="dialogRef.close()"
              (report)="onReport($event)"></cpd-report-issue>
          </div>
        </mat-tab>
      </mat-tab-group>
    </section>
  </ng-container>
  <ng-container *ngIf="isSubmited && alert">
    <section class="feedback-dialog__header grid-y align-middle">
      <img alt="" src="assets/images/dialog/feedback.svg" />
      <div class="cell">
        <div class="text-center font-semibold text-2xl">{{ alert.title }}</div>
      </div>
    </section>
    <section>
      <div *ngIf="alert.message" class="message">
        {{ alert.message }}
        <a
          role="button"
          tabindex="0"
          (keydown.enter)="goToStatusPage()"
          (keydown.space)="$event.preventDefault(); goToStatusPage()"
          class="link" (click)="goToStatusPage()">status page</a>.
      </div>
      <div class="py-6 text-center">
        <cpd-flat-button color="primary" text="Close" size="large" mat-dialog-close></cpd-flat-button>
      </div>
    </section>
  </ng-container>
</div>